import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blue-help-card',
  templateUrl: './blue-help-card.component.html',
  styleUrls: ['./blue-help-card.component.scss']
})
export class BlueHelpCardComponent implements OnInit {

  email: string = "ayuda@ingood.es"
  constructor() { }

  ngOnInit(): void {
  }

}
